import React from "react";
import Card from "../../Compenents/card";
import styles from './Service.module.css';
import im1 from '../../Compenents/assets/s.png';
import im2 from '../../Compenents/assets/s2.png';
import im3 from '../../Compenents/assets/s3.png';
import im4 from '../../Compenents/assets/s1.png';
import im5 from '../../Compenents/assets/s4.png';
import im6 from '../../Compenents/assets/5.png';

const Service = () => {
    return (
        <>
            <div id="service" className={styles.service}>
                <div className="container  wow bounceIn">
                    <h1>Nos Services</h1>
                    <Card img={im1} para={"Conception Logo"} img1={im2} para1={"Conception Marketing"} img2={im3} para2={"Conception Publicité"} />
                    <Card img={im4} para={"Design SiteWeb"} img1={im5} para1={"Site Vitrine"} img2={im6} para2={"Application Web"} />
                </div>
            </div>
        </>
    );
}
export default Service;